const l = {
  name: "Switzerland",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12.7,5c0.6,0,1-0.4,1-1s-0.4-1-1-1c-0.6,0-1,0.4-1,1S12.2,5,12.7,5z"/>
		<path class="st0" d="M10.7,0.6C9.6,1.3,8.8,2.5,8.7,3.8l0,0v0.6L0,21.8l4.8-3.1l0,0c1.4-1,2.7-2.1,3.9-3.4V20c0,2.3,1.7,4,4,4
			s4-1.7,4-4v-9.2l1.9,3.3L17,19l7-3.5l-0.9-1.8L20.4,15l0.4-1.1l-4.1-7.2V4c0-1-0.4-2.1-1.2-2.8C14.8,0.4,13.7,0,12.7,0
			C12,0,11.3,0.2,10.7,0.6L10.7,0.6L10.7,0.6z M8.7,8.9v3.3c-1,1.4-2.2,2.7-3.5,3.8L8.7,8.9z M10.7,20V3.9c0.1-1.1,1-1.9,2-1.9
			c0.6,0,1.1,0.2,1.3,0.5l0.1,0.1l0.1,0.1c0.3,0.3,0.5,0.8,0.5,1.3v16c0,1.1-0.8,2-2,2S10.7,21.1,10.7,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Switzerland
};
